import * as React from 'react';
import { ContractComparisonModel } from '../models';
import { ActionParams } from '../types';
import { Actions } from '../stores/ActionStore';
import { ActionId, ContractActionContext, ContractActionHandler } from './ContractActionContext';

type ComparisonHandlerMap = Partial<Record<ActionId, (params?: ActionParams) => Promise<void>>>;

const buildHandlers = (comparison: ContractComparisonModel): ComparisonHandlerMap => ({
    RebuildNodes: params => comparison.executeContractComparisonAction(Actions.RebuildNodes, params)
});

interface Props {
    contractComparison: ContractComparisonModel;
    children: React.ReactNode;
}

export const ComparisonActionProvider: React.FC<Props> = ({ contractComparison, children }) => {
    const handlers = React.useMemo(() => buildHandlers(contractComparison), [contractComparison]);

    const value = React.useMemo<ContractActionHandler>(
        () => ({
            async dispatch(actionId, params) {
                const handler = handlers[actionId];

                if (!handler) {
                    console.error(
                        `[ComparisonActionProvider] Action '${actionId}' is not supported in comparison context.`
                    );
                    return;
                }

                await handler(params);
            }
        }),
        [handlers]
    );

    return <ContractActionContext.Provider value={value}>{children}</ContractActionContext.Provider>;
};
